// extracted by mini-css-extract-plugin
module.exports = {"error":"SimpleAlert_error__1_IMd","success":"SimpleAlert_success__3WRv2"};